import { Org } from './org';
import { Flagrp_Fla } from './fla_grp';
import { Flagent_cfg } from './flagent_cfg';
import { Fldr } from './fldr';
import { Fla_Fldr } from './fla_fldr';
import { CommonEnums } from '../../common.enums';

export class Flagent {
    flagent_Id: number;
    nm: string;
    agentGrpFlg: string;
    description: string;
    host: string;
    port: string;
    drFlag: string;
    org_Id: number;
    owner_Id: number;
    privateFlg: string;
    orgs: Array<Org>;
    org_Nm: string;
    createBy: string;
    agentStatus: string;
    ownerNm: string;
    flagrp_Flas: Array<Flagrp_Fla>;
    imageUrl: string;
    dIVersion: string;
    updateDt: Date;
    updateBy: string;
    error_Cd: string;
    error_Msg: string;
    fla_Fldrs: Array<Fla_Fldr>;
    flagent_cfgs: Array<Flagent_cfg>;
    fldrs: Array<Fldr>;
    sslFlag: string;
    keystore_path: string;
    keyPassword: string;
    truststore_path: string;
    trustPassword: string;

    constructor() {
        this.flagent_Id = CommonEnums.defaults.LONG_VAL;
        this.nm = CommonEnums.defaults.STRING_EMPTY;
        this.agentGrpFlg = CommonEnums.defaults.STRING_EMPTY;
        this.description = CommonEnums.defaults.STRING_EMPTY;
        this.host = CommonEnums.defaults.STRING_EMPTY;
        this.port = CommonEnums.defaults.STRING_EMPTY;
        this.drFlag = CommonEnums.defaults.STRING_VAL_YES;
        this.org_Id = CommonEnums.defaults.LONG_VAL;
        this.owner_Id = CommonEnums.defaults.LONG_VAL;
        this.privateFlg = CommonEnums.defaults.STRING_VAL_YES;
        this.createBy = CommonEnums.defaults.STRING_EMPTY;
        this.orgs = new Array<Org>();
        this.org_Nm = "Default";
        this.agentStatus = CommonEnums.defaults.STRING_EMPTY;
        this.ownerNm = CommonEnums.defaults.STRING_EMPTY;
        this.flagrp_Flas = new Array<Flagrp_Fla>();
        this.imageUrl = CommonEnums.defaults.STRING_EMPTY;
        this.dIVersion = CommonEnums.defaults.STRING_EMPTY;
        this.updateDt = new Date();
        this.updateBy = CommonEnums.defaults.STRING_EMPTY;
        this.error_Cd = CommonEnums.defaults.ERROR_CD;
        this.error_Msg = CommonEnums.defaults.STRING_EMPTY;
        this.fla_Fldrs = new Array<Fla_Fldr>();
        this.flagent_cfgs = new Array<Flagent_cfg>();
        this.fldrs = new Array();
        this.sslFlag = CommonEnums.defaults.STRING_VAL_NO;
        this.keystore_path = CommonEnums.defaults.STRING_EMPTY;
        this.keyPassword = CommonEnums.defaults.STRING_EMPTY;
        this.truststore_path = CommonEnums.defaults.STRING_EMPTY;
        this.trustPassword = CommonEnums.defaults.STRING_EMPTY;
    }

    getPrimaryKey(): string {
        return this.flagent_Id.toString();
    }

    copy(): Flagent {
        let flagentTmp: Flagent = new Flagent();

        flagentTmp.flagent_Id = this.flagent_Id;
        flagentTmp.nm = this.nm;
        flagentTmp.agentGrpFlg = this.agentGrpFlg;
        flagentTmp.description = this.description;
        flagentTmp.host = this.host;
        flagentTmp.port = this.port;
        flagentTmp.drFlag = this.drFlag;
        flagentTmp.org_Id = this.org_Id;
        flagentTmp.owner_Id = this.owner_Id;
        flagentTmp.privateFlg = this.privateFlg;
        flagentTmp.createBy = this.createBy;
        flagentTmp.orgs = this.orgs;
        flagentTmp.org_Nm = this.org_Nm;
        flagentTmp.flagrp_Flas = this.flagrp_Flas;
        flagentTmp.agentStatus = this.agentStatus;
        flagentTmp.ownerNm = this.ownerNm;
        flagentTmp.imageUrl = this.imageUrl;
        flagentTmp.dIVersion = this.dIVersion;
        flagentTmp.updateDt = this.updateDt;
        flagentTmp.updateBy = this.updateBy;
        flagentTmp.error_Cd = this.error_Cd;
        flagentTmp.error_Msg = this.error_Msg;
        flagentTmp.fla_Fldrs = this.fla_Fldrs;
        flagentTmp.flagent_cfgs = this.flagent_cfgs;
        flagentTmp.fldrs = this.fldrs;
        flagentTmp.sslFlag = this.sslFlag;
        flagentTmp.keystore_path = this.keystore_path;
        flagentTmp.keyPassword = this.keyPassword;
        flagentTmp.truststore_path = this.truststore_path;
        flagentTmp.trustPassword = this.trustPassword;

        return flagentTmp;
    }

    copyFrom(flagentTmp: Flagent): void {
        if (!flagentTmp) return;

        this.flagent_Id = flagentTmp.flagent_Id;
        this.nm = flagentTmp.nm;
        this.agentGrpFlg = flagentTmp.agentGrpFlg;
        this.description = flagentTmp.description;
        this.host = flagentTmp.host;
        this.port = flagentTmp.port;
        this.drFlag = flagentTmp.drFlag;
        this.org_Id = flagentTmp.org_Id;
        this.owner_Id = flagentTmp.owner_Id;
        this.privateFlg = flagentTmp.privateFlg;
        this.createBy = flagentTmp.createBy;
        this.orgs = flagentTmp.orgs;
        this.org_Nm = flagentTmp.org_Nm;
        this.agentStatus = flagentTmp.agentStatus
        this.ownerNm = flagentTmp.ownerNm;
        this.flagrp_Flas = flagentTmp.flagrp_Flas;
        this.imageUrl = flagentTmp.imageUrl;
        this.dIVersion = flagentTmp.dIVersion;
        this.updateDt = flagentTmp.updateDt;
        this.updateBy = flagentTmp.updateBy;
        this.error_Cd = flagentTmp.error_Cd;
        this.error_Msg = flagentTmp.error_Msg;
        this.fla_Fldrs = flagentTmp.fla_Fldrs;
        this.flagent_cfgs = flagentTmp.flagent_cfgs;
        this.fldrs = flagentTmp.fldrs;
        this.sslFlag = flagentTmp.sslFlag;
        this.keystore_path = flagentTmp.keystore_path;
        this.keyPassword = flagentTmp.keyPassword;
        this.truststore_path = flagentTmp.truststore_path;
        this.trustPassword = flagentTmp.trustPassword;
    }

    compare(flagentTmp: Flagent): string {
        let flagentString: string = this.toString(false);
        let flagentTmpString: string = flagentTmp.toString(false);

        if (flagentString != flagentTmpString) {
            return flagentString + ', ' + flagentTmpString;
        }

        return '';
    }

    toString(isNotCompare: boolean = true): string {
        let str: string = "Flagent [flagent_Id=" + this.flagent_Id + ", nm=" + this.nm + ", description=" + this.description +
            ", host=" + this.host + ", port=" + this.port + ", drFlag=" + this.drFlag +
            ", flagent_cfgs=" + this.flagent_cfgs + ", fldrs=" + this.fldrs + ", agentGrpFlg=" + this.agentGrpFlg +
            ", org_Id=" + this.org_Id + ", updateDt=" + this.updateDt + ", updateBy=" + this.updateBy + ", privateFlg=" + this.privateFlg +
            ", owner_Id=" + this.owner_Id + ", sslFlag=" + this.sslFlag + ", keystore_path=" + this.keystore_path + ", keyPassword=" + this.keyPassword +
            ", truststore_path=" + this.truststore_path + ", trustPassword=" + this.trustPassword;



        if (isNotCompare) {

            str += ", fla_Fldrs=" + this.fla_Fldrs +
                ", orgs=" + this.orgs + ", org_Nm=" + this.org_Nm +
                ", createBy=" + this.createBy + ", agentStatus=" + this.agentStatus +
                ", ownerNm=" + this.ownerNm + ", flagrp_Flas=" + this.flagrp_Flas + ", imageUrl=" + this.imageUrl +
                ", dIVersion=" + this.dIVersion +
                ",error_Cd=" + this.error_Cd + ", error_Msg=" + this.error_Msg;
        }

        str += ']';

        return str;
    }
}